export enum ERedirectNotificationRoutes {
  REDIRECT_NOTIFICATION = 'RedirectNotification'
}
